// extracted by mini-css-extract-plugin
export default {"root":"OtpInput_root__yCubG","input":"OtpInput_input__eWQqR"};